import {
  DELETED_USERS,
  DELETED_USERS_SUCCESS,
  DELETED_USERS_FAILURE,
} from "../actionTypes";

export const deletedUsersList = (payload) => ({
  type: DELETED_USERS,
  payload,
});

export const deletedUsersSuccess = (payload) => ({
  type: DELETED_USERS_SUCCESS,
  payload,
});

export const deletedUsersFailure = () => ({
  type: DELETED_USERS_FAILURE,
});
